import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ComingSoonGuard implements CanActivate {
  private router = inject(Router);

  canActivate(): boolean | UrlTree {
    const enabled = String(environment.comingSoon) === 'true';
    return enabled ? this.router.parseUrl('/coming-soon') : true;
  }
}
